export var InvitationStatusEnum;
(function (InvitationStatusEnum) {
    InvitationStatusEnum[InvitationStatusEnum["Pending"] = 1] = "Pending";
    InvitationStatusEnum[InvitationStatusEnum["InProgress"] = 2] = "InProgress";
    InvitationStatusEnum[InvitationStatusEnum["Registered"] = 3] = "Registered";
    InvitationStatusEnum[InvitationStatusEnum["Invited"] = 4] = "Invited";
    InvitationStatusEnum[InvitationStatusEnum["Expired"] = 5] = "Expired";
    InvitationStatusEnum[InvitationStatusEnum["Declined"] = 6] = "Declined";
})(InvitationStatusEnum || (InvitationStatusEnum = {}));
export const InvitationStatusMap = new Map([
    [InvitationStatusEnum.Pending, "Pending"],
    [InvitationStatusEnum.InProgress, "InProgress"],
    [InvitationStatusEnum.Registered, "Registered"],
    [InvitationStatusEnum.Invited, "Invited"],
    [InvitationStatusEnum.Expired, "Expired"],
    [InvitationStatusEnum.Declined, "Declined"],
]);
